import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { EntityImage } from '../common';
import { logger } from '../common/lib/logger';
export var MemberBadgeLocation;
(function (MemberBadgeLocation) {
    MemberBadgeLocation["PostMemberBar"] = "PostMemberBar";
    MemberBadgeLocation["ProfileName"] = "ProfileName";
    MemberBadgeLocation["MembersList"] = "MembersList";
})(MemberBadgeLocation || (MemberBadgeLocation = {}));
export const getBadgeSetting = (badge, key) => {
    var _a;
    if (!(badge === null || badge === void 0 ? void 0 : badge.settings))
        return null;
    const property = (_a = badge === null || badge === void 0 ? void 0 : badge.settings) === null || _a === void 0 ? void 0 : _a.find(prop => prop.key === key);
    if (!property)
        return null;
    try {
        return JSON.parse(property === null || property === void 0 ? void 0 : property.value);
    }
    catch (err) {
        logger.error('Could not read extra property of badge', err);
    }
};
export const MemberBadge = ({ badge, memberBadge, size = 'sm', showTooltip = false, }) => {
    if (!badge && memberBadge.badge)
        badge = memberBadge.badge;
    const style = getBadgeSetting(badge, 'style');
    if (style === 'image' && (badge === null || badge === void 0 ? void 0 : badge.image)) {
        const sizeMap = {
            xs: 'xxs',
            sm: 'xs',
            md: 'xsm',
            lg: 'sm',
        };
        const badgeComponent = (_jsx("div", { className: "flex", children: _jsx(EntityImage, { entity: badge, size: sizeMap[size] }, void 0) }, void 0));
        if (!showTooltip || !(badge === null || badge === void 0 ? void 0 : badge.shortDescription))
            return badgeComponent;
        return (_jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { className: "flex", children: badgeComponent }, void 0), _jsx(Tooltip.Panel, { children: badge.shortDescription }, void 0)] }, void 0));
    }
    const sizeMap = {
        xs: 'sm',
        sm: 'md',
        md: 'lg',
        lg: 'lg',
    };
    const badgeComponent = (_jsx("div", { className: "overflow-hidden max-w-[150px] flex", children: _jsx(Badge, { className: "rounded-md cursor-default truncate block", size: sizeMap[size], style: {
                backgroundColor: badge.backgroundColor || '#f3f4f6',
                color: badge.textColor || '#1f2937',
            }, children: (memberBadge === null || memberBadge === void 0 ? void 0 : memberBadge.text) || (badge === null || badge === void 0 ? void 0 : badge.text) || (badge === null || badge === void 0 ? void 0 : badge.name) }, void 0) }, void 0));
    if (!showTooltip || !(badge === null || badge === void 0 ? void 0 : badge.shortDescription))
        return badgeComponent;
    return (_jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { className: "flex", children: badgeComponent }, void 0), _jsx(Tooltip.Panel, { children: badge === null || badge === void 0 ? void 0 : badge.shortDescription }, void 0)] }, void 0));
};
//# sourceMappingURL=MemberBadge.js.map